import { commonStrings } from "../../../components/StringBundle"

export const GetColumns = () => {
    return {
        categories: [
            { label: commonStrings.export, value: 'Export' },
            { label: commonStrings.domestic, value: 'Domestic' }
        ],
    }
}